export default __webpack_public_path__ + "static/media/traverse.2e80f68b.jpg";